import { GameObj } from "../GameObj";
import { positionsInRadius } from "../geometry";
import { globals } from "../types";
import { UnitType } from "./UnitType";
import type { UnitContext, PlaceContext, ObjContext, MakeContext } from "./context";

export class ConversionRitual extends UnitType {
    readonly id = "conversion ritual";
    readonly displayName = "conversion ritual";
    playerCanDeploy(ctx: UnitContext) { return ctx.world === ctx.game.overworld; }
    playerCanControl() { return false; }
    canEnter(ctx: PlaceContext) { return ctx.world.get(ctx.x, ctx.y)?.unitId === "priest" && this.inTile(ctx, ["land"], ctx.game.overworld); }
    description() { return "Converts priests to cultists."; }
    maxCooldown() { return 0; }
    cost() { return { souls: 0, blood: 200, runes: 2 }; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "conversion ritual"); }
    defeats(): (string | true)[] { return ["priest"]; }
    aiAlwaysSteps(): boolean { return true; }
    step(ctx: ObjContext) {
        const { obj, world, x, y } = ctx;
        globals.audio.playSound("wird");
        // add animation maybe
        ctx.game.stats.recordConversion();
        world.remove(x, y);
        world.set(x, y, ctx.game.units["cultist"].make({ faction: ctx.faction }))
        world.get(x, y)?.setNotReady();
    }
}
